import { $axios } from "lib/axios";
import { TMember } from "types/auth/authTypes";
import { TVerificationType } from "types/commonTypes";
import { TSignUpReq } from "types/signup/signUpTypes";

export const postSignup = async ({ memberType, normalParams, corporationParams }: TSignUpReq) => {
  const requestData = memberType === "normal" ? normalParams : corporationParams;
  const res = await $axios.post(`/member/${memberType}`, requestData);
  return res.data;
};

export const getDuplicatedCheckPhoneNumberOrEmail = async ({
  type,
  phoneNumber,
  email,
}: {
  type: TMember;
  phoneNumber?: string;
  email?: string;
}) => {
  const endpoint =
    type === "normal" ? "phone-number" : phoneNumber ? "manager-phone-number" : "email";

  const res = await $axios.get<boolean>(`/member/${type}/${endpoint}/${phoneNumber || email}`);

  return res.data;
};

export const getDuplicatedCheckNormalEmail = async (email: string) => {
  const res = await $axios.get<boolean>(`/member/normal/email/${email}`);

  return res.data;
};

export const getDuplicatedCheckBusinessLicenseNumber = async (businessLicenseNumber: string) => {
  const res = await $axios.get(
    `/member/corporation/business-license-number/${businessLicenseNumber}`
  );
  return res.data;
};

export const sendVerification = async ({
  memberType,
  type,
  phoneNumber,
  email,
}: {
  memberType: TMember;
  type: TVerificationType;
  phoneNumber?: string;
  email?: string;
}) => {
  const requestData = type === "sms" ? { phoneNumber } : { email };
  const res = await $axios.post(`/member/${memberType}/signup/${type}`, requestData);
  return res.data;
};
